<script lang="ts">
  import CardItem from "../Card/CardItem.svelte";
  import type { PersistedAddress } from "../../lib/api/address";
  import Pin from "../../assets/icons/address/pin.svg";
  import AdditionalInfo from "../../assets/icons/address/additional-info.svg";
  import DeliveryType from "../../assets/icons/address/stocks.svg";
  import Note from "../../assets/icons/address/add-comment.svg";
  import { setAddressForEdit } from "../../lib/stores/addresses";
  import { getCopy } from "../../lib/stores/copy";
  import BaseCard from "../Card/BaseCard.svelte";
  import { getDeliveryInstructions, getNoContact, getFormattedAddress } from "../../lib/helpers/address";
  import PATHS from "../../lib/constants/routePaths";
  import { navigateToPath } from "../../lib/routing";

  export let selectedAddress: PersistedAddress;
  export let hideEditButton: boolean = false;
  export let onCardEditCallback: () => Promise<void> = async () => {};

  const onEditClick = () => {
    void (async () => {
      await onCardEditCallback();
      setAddressForEdit(selectedAddress);
      navigateToPath(PATHS.ADDRESS);
    })();
  };

  $: copy = $getCopy("address") as Record<string, string>;
  $: noContactDelivery = getNoContact(selectedAddress);
  $: deliveryInstructions = getDeliveryInstructions(selectedAddress) || "-";
  $: address2 = selectedAddress?.address2 || "-";
  $: formattedAddress = getFormattedAddress(selectedAddress);
  $: disableNoContact = copy.disableNoContact as unknown as boolean;
  $: disableNote = copy.disableNote as unknown as boolean;
</script>

<BaseCard headerCopy={copy.addressCardHeaderCopy} onEditClick={onEditClick} {hideEditButton}>
  <svelte:fragment slot="card items">
    <CardItem label={copy.addressLabel} value={formattedAddress} icon={Pin} />
    <CardItem label={copy.address2Placeholder} value={address2} icon={AdditionalInfo} />
    {#if !disableNoContact}
      <CardItem
        label={copy.deliveryTypeLabel}
        value={noContactDelivery ? copy.noContactDeliveryType : copy.normalDeliveryType}
        icon={DeliveryType} />
    {/if}
    {#if !disableNote}
      <CardItem label={copy.deliveryInstructionsLabel} value={deliveryInstructions} icon={Note} />
    {/if}
  </svelte:fragment>
</BaseCard>
